import React from "react";
import loadable from "@loadable/component";

export const Card = loadable(() => import("./card"));
export const Rates = loadable(() => import("./rates"));
export const RatesTags = loadable(() => import("./ratesTags"));
export const ActionsList = loadable(() => import("./actionsList"));
export const ConnectTariff = loadable(() => import("./connect"));
export const RatingReview = loadable(() => import("./ratingReview"));
